import { Kustomer, KustomerQueuedMethod, KustomerMethods } from 'widget/types';
import {
  KustomerCore,
  KustomerCoreQueuedMethod,
  KustomerCoreMethods,
} from 'core/types';

// eslint-disable-next-line import/prefer-default-export
export const runQueue = (api: Kustomer | KustomerCore): void => {
  api.q.forEach((entry: KustomerCoreQueuedMethod | KustomerQueuedMethod) => {
    const keys = Object.keys(entry);
    const method = keys[0] as KustomerCoreMethods | KustomerMethods;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore ignoring next line due to issue with union
    const params = entry[method] as
      | Parameters<KustomerCore[KustomerCoreMethods]>
      | Parameters<Kustomer[KustomerMethods]>;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore ignoring next line due to issue with union
    const methodFn = api[method]?.bind(api);

    if (!methodFn) return undefined;

    if (params) {
      return methodFn(...params);
    }

    return methodFn();
  });
};
